/**
 * W-3 首页(WScreen-3 home.md)。Hero + 一级品类 tab + 推荐流多列网格。
 * cursor 分页 + 跨页去重 + 三重终止;品类切换同屏重查 + 本地记忆;五态齐全。
 */
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCategories, useProductFeed } from '@/hooks/browse';
import { l1Nodes } from '@/lib/categoryTree';
import { dedupeById } from '@/lib/dedupe';
import { getHomeCategory, setHomeCategory } from '@/lib/browseStore';
import { CategoryTabs } from '@/components/browse/CategoryTabs';
import { ProductGrid } from '@/components/browse/ProductGrid';
import { GridSkeleton } from '@/components/browse/GridSkeleton';
import { StateBlock } from '@/components/browse/StateBlock';

export function HomePage() {
  const [selectedL1, setSelectedL1] = useState<string | null>(() => getHomeCategory());
  const categoriesQ = useCategories();
  const feed = useProductFeed(selectedL1 ?? undefined);

  const tabs = useMemo(() => l1Nodes(categoriesQ.data ?? []), [categoriesQ.data]);
  const items = useMemo(
    () => dedupeById((feed.data?.pages ?? []).flatMap((p) => p.items ?? [])),
    [feed.data],
  );

  const onSelect = (id: string | null) => {
    setSelectedL1(id);
    setHomeCategory(id);
  };

  return (
    <>
      <section className="hero">
        <div className="hero-inner">
          <div style={{ flex: 1 }}>
            <h1>找人搭把手，顺手淘闲置</h1>
            <p>
              陪练陪读、私教倾诉,或同城二手好物 —— 都是身边真实的人,按次下单,聊明白再开始。
            </p>
            <div className="row gap-4 mt-6">
              <Link to="/search" className="btn btn-primary btn-lg">
                开始发现
              </Link>
              <Link to="/publish" className="btn btn-secondary btn-lg">
                我要接单
              </Link>
            </div>
          </div>
        </div>
      </section>

      <div className="inner section">
        <CategoryTabs categories={tabs} selectedId={selectedL1} onSelect={onSelect} />
        <div className="row between mb-6">
          <h2 className="h2">为你推荐</h2>
        </div>

        {feed.isLoading ? (
          <GridSkeleton />
        ) : feed.isError && items.length === 0 ? (
          <StateBlock
            icon="⚠️"
            title="网络异常,点击重试"
            actionLabel="重试"
            onAction={() => feed.refetch()}
          />
        ) : items.length === 0 ? (
          <StateBlock icon="📭" title="暂无数据" />
        ) : (
          <ProductGrid
            items={items}
            hasNextPage={feed.hasNextPage}
            isFetchingNextPage={feed.isFetchingNextPage}
            isPageError={feed.isError && items.length > 0}
            onLoadMore={() => feed.fetchNextPage()}
          />
        )}
      </div>
    </>
  );
}
